import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { TranslateService } from '@ngx-translate/core';
import { ReturnAllDateComponent } from '../return-all-date/return-all-date.component';
import { TypeModifier } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-invoice-detail',
  templateUrl: './invoice-detail.component.html',
  styleUrls: ['./invoice-detail.component.css']
})
export class InvoiceDetailComponent implements OnInit {

  type = '';
  no = '';
  source = '';
  urlParts = [];

  page_title = '';
  company_tax_no = '';
  route_list = [];
  button_list = [];
  invoice_detail = { 'comment': '' };
  top_part = [];
  bottom_part = [];

  private dp = [];
  public menu_item_id;
  public add_auth;
  public edit_auth;
  public del_auth;
  displayedColumns = ['sub_item_no', 'sub_item_name', 'unit_name', 'price', 'count', 'total_price', 'discount',
    'tax_name_ar', 'tax_amount', 'net_total', 'comment'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;

  returnDateDialogRef: MatDialogRef<ReturnAllDateComponent>;

  Qutation_Detail; Invoice_Detail; Qutation_No; Qutation_Date; From_Branch;
  Print_Date; Tax_Number; Qutation_Status; Customer_Tax_No; Total_After_Discount;
  Total_With_Tax; Employee_Name; Invoice_Date; Invoice_Status; Supplier_Name;
  Del_Msg; Success_Msg; Error_Msg; Supplier_Tax_No; Representative; Taxes;
  Expiry_Date; Customer_Name; Mobile; Amount_Total; Invoice_No;
  Discount; Pay_Method; Delivered; Pending; Maint_Detail; Repair_Req_No;
  Repair_Req_Date; Meter_Reading; Appoint_Date;
  Request_Detail; Request_No; Request_Date; Request_Type;
  Table_No; Pur_Order_No; Pur_Order_Detail; Pur_Order_Date;
  Pur_Order_Status; Is_Received; Cancel_Invoice_Msg; Ret_No_Msg;
  Ret_All_Msg; 

  constructor(private route: ActivatedRoute, private utils: Utils, public applicationConstants: ApplicationConstants,
    private router: Router, public translate: TranslateService, public dialog: MatDialog) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Qutation_Detail').subscribe((res: string) => {
      this.Qutation_Detail = res;
    });

    translate.get('Invoice_Detail').subscribe((res: string) => {
      this.Invoice_Detail = res;
    });

    translate.get('Qutation_No').subscribe((res: string) => {
      this.Qutation_No = res;
    });

    translate.get('Qutation_Date').subscribe((res: string) => {
      this.Qutation_Date = res;
    });

    translate.get('From_Branch').subscribe((res: string) => {
      this.From_Branch = res;
    });

    translate.get('Tax_Number').subscribe((res: string) => {
      this.Tax_Number = res;
    });

    translate.get('Qutation_Status').subscribe((res: string) => {
      this.Qutation_Status = res;
    });

    translate.get('Customer_Tax_No').subscribe((res: string) => {
      this.Customer_Tax_No = res;
    });

    translate.get('Total_After_Discount').subscribe((res: string) => {
      this.Total_After_Discount = res;
    });

    translate.get('Total_With_Tax').subscribe((res: string) => {
      this.Total_With_Tax = res;
    });

    translate.get('Employee_Name').subscribe((res: string) => {
      this.Employee_Name = res;
    });

    translate.get('Invoice_Date').subscribe((res: string) => {
      this.Invoice_Date = res;
    });

    translate.get('Print_Date').subscribe((res: string) => {
      this.Print_Date = res;
    });

    translate.get('Invoice_Status').subscribe((res: string) => {
      this.Invoice_Status = res;
    });

    translate.get('Supplier_Name').subscribe((res: string) => {
      this.Supplier_Name = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Supplier_Tax_No').subscribe((res: string) => {
      this.Supplier_Tax_No = res;
    });

    translate.get('Representative').subscribe((res: string) => {
      this.Representative = res;
    });

    translate.get('Taxes').subscribe((res: string) => {
      this.Taxes = res;
    });

    translate.get('Expiry_Date').subscribe((res: string) => {
      this.Expiry_Date = res;
    });

    translate.get('Customer_Name').subscribe((res: string) => {
      this.Customer_Name = res;
    });

    translate.get('Mobile').subscribe((res: string) => {
      this.Mobile = res;
    });

    translate.get('Amount_Total').subscribe((res: string) => {
      this.Amount_Total = res;
    });

    translate.get('Invoice_No').subscribe((res: string) => {
      this.Invoice_No = res;
    });

    translate.get('Discount').subscribe((res: string) => {
      this.Discount = res;
    });

    translate.get('Pay_Method').subscribe((res: string) => {
      this.Pay_Method = res;
    });

    translate.get('Delivered').subscribe((res: string) => {
      this.Delivered = res;
    });

    translate.get('Pending').subscribe((res: string) => {
      this.Pending = res;
    });

    translate.get('Maint_Detail').subscribe((res: string) => {
      this.Maint_Detail = res;
    });

    translate.get('Repair_Req_No').subscribe((res: string) => {
      this.Repair_Req_No = res;
    });

    translate.get('Repair_Req_Date').subscribe((res: string) => {
      this.Repair_Req_Date = res;
    });

    translate.get('Meter_Reading').subscribe((res: string) => {
      this.Meter_Reading = res;
    });

    translate.get('Appoint_Date').subscribe((res: string) => {
      this.Appoint_Date = res;
    });

    translate.get('Request_Detail').subscribe((res: string) => {
      this.Request_Detail = res;
    });

    translate.get('Request_No').subscribe((res: string) => {
      this.Request_No = res;
    });

    translate.get('Request_Date').subscribe((res: string) => {
      this.Request_Date = res;
    });

    translate.get('Request_Type').subscribe((res: string) => {
      this.Request_Type = res;
    });

    translate.get('Table_No').subscribe((res: string) => {
      this.Table_No = res;
    });

    translate.get('Pur_Order_No').subscribe((res: string) => {
      this.Pur_Order_No = res;
    });

    translate.get('Pur_Order_Detail').subscribe((res: string) => {
      this.Pur_Order_Detail = res;
    });

    translate.get('Pur_Order_Date').subscribe((res: string) => {
      this.Pur_Order_Date = res;
    });

    translate.get('Pur_Order_Status').subscribe((res: string) => {
      this.Pur_Order_Status = res;
    });

    translate.get('Is_Received').subscribe((res: string) => {
      this.Is_Received = res;
    });

    translate.get('Ret_No_Msg').subscribe((res: string) => {
      this.Ret_No_Msg = res;
    });

    translate.get('Cancel_Invoice_Msg').subscribe((res: string) => {
      this.Cancel_Invoice_Msg = res;
    });
    
    translate.get('Ret_All_Msg').subscribe((res: string) => {
      this.Ret_All_Msg = res;
    });
  }

  ngOnInit() {
    this.company_tax_no = this.utils.getParamValue('company_tax_no');
    this.route_list = [];
    this.button_list = [];

    this.route.params.subscribe(params => {
      // console.log(params);
      this.type = params['type'];
      this.no = params['no'];
      this.source = params['source'];

      let href = this.router.url;
      this.urlParts = href.split("/");

      /////////////////////////// page title and button list ///////////////////////////
      //******************************************* Type: Qutation *******************************************//
      if (this.type == 'qutation') {

        if (this.urlParts[2] == '1') {
          this.menu_item_id = '14';
        }
        else if (this.urlParts[2] == '12') {
          this.menu_item_id = '81';
        }

        this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
        this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
        this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

        if (this.menu_item_id == '14') {
          this.page_title = this.Qutation_Detail;
          this.route_list.push({
            'button_name': 'عودة للقائمة', 'button_name_en': 'Back to List',
            'router_link': '../../../../' + this.source
          });

          // if (this.edit_auth) {
          //   this.route_list.push({
          //     'button_name': 'تعديل التسعيرة', 'button_name_en': 'Edit Qutation',
          //     'router_link': ''
          //   });
          // }
          this.route_list.push({
            'button_name': 'تصدير لفاتورة', 'button_name_en': 'Export Invoice',
            'router_link': '../../../../invoice/invoice/export_qutation/' + this.no
          });


          this.button_list = [{
            'id': 'btn_print', 'button_name': 'طباعة التسعيرة',
            'button_name_en': 'Print Quotation', 'op_type': 'print'
          }];

          this.route_list.push({
            'button_name': 'نسخ التسعيرة', 'button_name_en': 'Copy Quotation',
            'router_link': '../../../../qutation/' + this.no + '/copy'
          });

        }
        else if (this.menu_item_id == '81') {
          this.page_title = this.Maint_Detail;
          this.route_list.push({
            'button_name': 'عودة للقائمة', 'button_name_en': 'Back to List',
            'router_link': '../../../../' + this.source
          });
          if (this.edit_auth) {
            this.route_list.push({
              'button_name': 'تعديل طلب الإصلاح', 'button_name_en': 'Edit Repair Request',
              'router_link': ''
            });
          }
          this.route_list.push({
            'button_name': 'تصدير فاتورة', 'button_name_en': 'Export Invoice',
            'router_link': '../../../../invoice/invoice/export_qutation/' + this.no
          });


          this.button_list = [{
            'id': 'btn_print', 'button_name': 'طباعة طلب الإصلاح',
            'button_name_en': 'Print Repair Request', 'op_type': 'print'
          }];

          if (this.del_auth) {
            this.button_list.push({
              'id': 'btn_del_qutation', 'button_name': 'إلغاء طلب الإصلاح',
              'button_name_en': 'Delete Repair Request', 'op_type': 'delete'
            });
          }
        }

      }

      //******************************************* Type: Invoice *******************************************//
      else if (this.type == 'invoice') {

        this.page_title = this.Invoice_Detail;

        if (this.urlParts[2] == '1') 
          this.menu_item_id = '12'; 

        else if (this.urlParts[2] == '3')
          this.menu_item_id = '65';

        else if (this.urlParts[2] == '4') {
          if (this.source == 'income_report')
            this.menu_item_id = '68';
          else if (this.source == 'expenses_income_report')
            this.menu_item_id = '72';
          else if (this.source == 'delivery_report')
            this.menu_item_id = '103';
        }

        else if (this.urlParts[2] == '8') 
          this.menu_item_id = '12';
        
        else if (this.urlParts[2] == '12') 
          this.menu_item_id = '83';
        
          
        this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
        this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
        this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

        this.route_list.push({
          'button_name': 'عودة للقائمة', 'button_name_en': 'Back to List',
          'router_link': '../../../../' + this.source
        });
        // if (this.edit_auth) {
        //   this.route_list.push({
        //     'button_name': 'تعديل الفاتورة', 'button_name_en': 'Edit Invoice',
        //     'router_link': '../../../invoice/' + this.type + '/edit/' + this.no
        //   });
        // }

        this.button_list = [{
          'id': 'btn_print', 'button_name': 'طباعة الفاتورة',
          'button_name_en': 'Print Invoice', 'op_type': 'print'
        }];

        this.button_list.push({
          'id': 'btn_printThermal', 'button_name': 'طباعة الفاتورة المبسطة',
          'button_name_en': 'Print Simplified Invoice', 'op_type': 'printThermal'
        });
      }

      //**************************************** Type: supplier_invoice ****************************************//
      else if (this.type == 'supplier_invoice') {
        this.page_title = this.Invoice_Detail;

        if (this.urlParts[2] == '7') 
          this.menu_item_id = '19';
        else if (this.urlParts[2] == '4') {
          if (this.source == 'expenses_report')
            this.menu_item_id = '62';
          else if (this.source == 'expenses_income_report')
            this.menu_item_id = '72';
          else if (this.source == 'receipt_report')
            this.menu_item_id = '104';
        }
        else  if (this.urlParts[2] == '2') 
          this.menu_item_id = '19';

        this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
        this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
        this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

        this.route_list.push({
          'button_name': 'عودة للقائمة', 'button_name_en': 'Back to List',
          'router_link': '../../../../' + this.source
        });

        if (this.add_auth) {
          this.route_list.push({
            'button_name': 'نسخ الفاتورة', 'button_name_en': 'Copy Invoice',
            'router_link': '../../../../supplier_invoice/' + 'copy/' + this.no
          });
        }

        this.button_list.push({
          'id': 'btn_print', 'button_name': 'طباعة الفاتورة',
          'button_name_en': 'Normal Print', 'op_type': 'print'
        });
        //{ 'button_name': 'طباعة حرارية', 'button_name_en': 'Thermal Print', 'op_type': 'thermal_print' },
        // this.button_list.push({ 'id': 'btn_receive', 'button_name': 'استلام', 'button_name_en': 'Receive', 'op_type': 'receive' });
        // this.button_list.push({ 'id': 'btn_print_receipt', 'button_name': 'طباعة بيان الاستلام', 'button_name_en': 'Print Receipt', 'op_type': 'print_receipt' });
      }

      //******************************************* Type: Return Invoice *******************************************//
      else if (this.type == 'return_invoice') {

        this.page_title = this.Invoice_Detail;
        this.menu_item_id = '22';
        this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
        this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

        this.route_list.push({
          'button_name': 'عودة للقائمة', 'button_name_en': 'Back to List',
          'router_link': '../../../../' + this.source
        });

        this.button_list.push({
          'id': 'btn_print', 'button_name': 'طباعة الفاتورة',
          'button_name_en': 'Print Invoice', 'op_type': 'print'
        });
      }

      //******************************************* Type: Return Supplier Invoice *******************************************//
      else if (this.type == 'return_supplier_invoice') {

        this.page_title = this.Invoice_Detail;
        this.menu_item_id = '58';
        this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
        this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

        this.route_list.push({
          'button_name': 'عودة للقائمة', 'button_name_en': 'Back to List',
          'router_link': '../../../../' + this.source
        });

        this.button_list = [{
          'id': 'btn_print', 'button_name': 'طباعة الفاتورة',
          'button_name_en': 'Print Invoice', 'op_type': 'print'
        }];
      }

      //******************************************* Type: Request *******************************************//
      else if (this.type == 'request') {

        this.menu_item_id = '73';
        this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
        this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
        this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

        this.page_title = this.Request_Detail;

        this.route_list.push({
          'button_name': 'عودة للقائمة', 'button_name_en': 'Back to List',
          'router_link': '../../../../' + this.source
        });


        // this.button_list = [{ 'id': 'btn_print', 'button_name': 'طباعة الطلب', 'button_name_en': 'Print Order', 'op_type': 'print' }];
        // if (this.del_auth) {
        //   this.button_list.push({
        //     'id': 'btn_del_request', 'button_name': 'حذف الطلب',
        //     'button_name_en': 'Delete Order', 'op_type': 'delete'
        //   });
        // }
        // this.button_list.push({ 'id': 'btn_delivery', 'button_name': 'تسليم', 'button_name_en': 'Delivery', 'op_type': 'delivery' });
        // this.button_list.push({ 'id': 'btn_print_delivery', 'button_name': 'طباعة بيان التسليم', 'button_name_en': 'Print delivery statement', 'op_type': 'print_delivery' });

      }


      //******************************************* Type: Purchase Order *******************************************//
      if (this.type == 'purchase_order') {
        this.menu_item_id = '101';
        this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
        this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

        this.page_title = this.Pur_Order_Detail;

        this.route_list.push({
          'button_name': 'عودة للقائمة', 'button_name_en': 'Back to List',
          'router_link': '../../../../' + this.source
        });

        // if (this.edit_auth) {
        //   this.route_list.push({
        //     'button_name': 'تعديل أمر الشراء', 'button_name_en': 'Edit Order',
        //     'router_link': ''
        //   });
        // }
        this.route_list.push({
          'button_name': 'تصدير فاتورة', 'button_name_en': 'Export Invoice',
          'router_link': '../../../../supplier_invoice/export_pur_order/' + this.no
        });

        this.button_list = [{
          'id': 'btn_print', 'button_name': 'طباعة أمر الشراء',
          'button_name_en': 'Print Order', 'op_type': 'print'
        }];
        if (this.del_auth) {
          this.button_list.push({
            'id': 'btn_del_order', 'button_name': 'إلغاء أمر الشراء',
            'button_name_en': 'Delete Order', 'op_type': 'delete'
          });
        }
      }

      /////////////////////////// get invoice detail ///////////////////////////
      let obj = { cmd: 'getInvoiceDetail', type: this.type, no: this.no };
      
      this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          this.invoice_detail = data.status['msg'];

          if (this.type == 'invoice') {
            if (this.invoice_detail['invoice_type'] != 'advanced' && this.invoice_detail['invoice_type'] != 'install' && this.add_auth) {
              this.route_list.push({
                'button_name': 'نسخ الفاتورة', 'button_name_en': 'Copy Invoice',
                'router_link': '../../../../invoice/' + this.type + '/copy/' + this.no
              });
            }

            if (this.invoice_detail['status'] != '3') {
              if (this.invoice_detail['invoice_type'] != 'advanced' && this.invoice_detail['invoice_type'] != 'install' && 
                this.invoice_detail['invoice_type'] != 'qty_install' && this.edit_auth && this.invoice_detail['is_locked'] == '0') {
                this.route_list.push({
                  'button_name': 'ترجيع الفاتورة', 'button_name_en': 'Return Invoice',
                  'router_link': '../../../../return_invoice/' + this.no
                });
              }

              if (this.invoice_detail['return_all'] == '1' && this.del_auth && this.invoice_detail['is_locked'] == '0') {
                this.button_list.push({
                  'id': 'btn_del_invoice', 'button_name': 'ترجيع كامل الفاتورة',
                  'button_name_en': 'Return Full Invoice', 'op_type': 'cancel'
                });
              }

              if (this.invoice_detail['status'] == '2') {
                if (this.edit_auth)
                  this.button_list.push({ 'id': 'btn_delivery', 'button_name': 'تسليم', 
                    'button_name_en': 'Delivery', 'op_type': 'delivery' });
              }
              else if (this.invoice_detail['status'] == '1')
                this.button_list.push({ 'id': 'btn_print_delivery', 'button_name': 'طباعة بيان التسليم', 
                  'button_name_en': 'Print delivery statement', 'op_type': 'print_delivery' });
            }
          }
          else if (this.type == 'qutation') {
            if (this.invoice_detail['invoice_no'] == '') {
              if (this.edit_auth)
                this.route_list.push({
                  'button_name': 'تعديل التسعيرة', 'button_name_en': 'Edit Quotation',
                  'router_link': '../../../../qutation/' + this.no
                });

                if (this.del_auth) {
                  this.button_list.push({
                    'id': 'btn_del_qutation', 'button_name': 'إلغاء التسعيرة',
                    'button_name_en': 'Delete Quotation', 'op_type': 'delete'
                  });
                }
            }
          }
          else if (this.type == 'supplier_invoice') {

            if (this.edit_auth && this.invoice_detail['is_locked'] == '0') {
              this.route_list.push({
                'button_name': 'تعديل الفاتورة', 'button_name_en': 'Edit Invoice',
                'router_link': '../../../../supplier_invoice/' + this.no
              });
    
              this.route_list.push({
                'button_name': 'ترجيع الفاتورة', 'button_name_en': 'Return Invoice',
                'router_link': '../../../../return_supplier_invoice/' + this.no
              });
            }
    
            if (this.del_auth && this.invoice_detail['is_locked'] == '0') {
              this.button_list.push({
                'id': 'btn_del_sup_inv', 'button_name': 'حذف الفاتورة',
                'button_name_en': 'Delete Invoice', 'op_type': 'delete'
              });
            }

            if (this.invoice_detail['received'] == '2') {
              if (this.edit_auth)
                this.button_list.push({ 'id': 'btn_receive', 'button_name': 'استلام', 
                  'button_name_en': 'Receive', 'op_type': 'receive' });
            }
            else
              this.button_list.push({ 'id': 'btn_print_receipt', 'button_name': 'طباعة بيان الاستلام', 
                'button_name_en': 'Print Receipt', 'op_type': 'print_receipt' });
          }
          else if (this.type == 'request') {
            if (this.invoice_detail['invoice_no'] != '') {
              this.button_list = [{
                'id': 'btn_print', 'button_name': 'طباعة الفاتورة',
                'button_name_en': 'Print Invoice', 'op_type': 'print'
              }];
      
              this.button_list.push({
                'id': 'btn_printThermal', 'button_name': 'طباعة الفاتورة المبسطة',
                'button_name_en': 'Print Simplified Invoice', 'op_type': 'printThermal'
              });
              
              if (this.invoice_detail['status'] != '3' && this.del_auth) {
                this.button_list.push({
                  'id': 'btn_del_invoice', 'button_name': 'ترجيع كامل الفاتورة',
                  'button_name_en': 'Return Invoice', 'op_type': 'cancel'
                });
              }
            }
            else {
              this.button_list.push({
                'id': 'btn_printThermal', 'button_name': 'طباعة الطلب',
                'button_name_en': 'Print Order', 'op_type': 'printThermal'
              });

              if (this.edit_auth) {
                this.route_list.push({
                  'button_name': 'تعديل/ حساب', 'button_name_en': 'Edit/ Calculate',
                  'router_link': '../../../../sale_point/' + this.no + '/null'
                });  // this.type + '/edit/' + 
              }
            }

            if (this.invoice_detail['res_status'] == '2') {
              if (this.edit_auth)
                this.button_list.push({ 
                  'id': 'btn_free_table', 'button_name': 'إفراغ الطاولة', 
                  'button_name_en': 'Free Table', 'op_type': 'free_table' 
                });
            }
          }
          else if (this.type == 'return_invoice') {
            if (this.invoice_detail['status'] != '3') {
              if (this.edit_auth && this.invoice_detail['is_locked'] == '0') {
                this.button_list.push({
                  'id': 'btn_edit', 'button_name': 'تعديل الفاتورة',
                  'button_name_en': 'Edit Invoice', 'op_type': 'edit'
                });
              }

              // if (this.del_auth && this.invoice_detail['is_locked'] == '0') {
              //   this.button_list.push({
              //     'id': 'btn_del_ret_inv', 'button_name': 'حذف الفاتورة',
              //     'button_name_en': 'Delete Invoice', 'op_type': 'delete'
              //   });
              // }
            }
          }
          else if (this.type == 'return_supplier_invoice') {
            if (this.edit_auth && this.invoice_detail['is_locked'] == '0') {
              this.route_list.push({
                'button_name': 'تعديل الفاتورة', 'button_name_en': 'Edit Invoice',
                'router_link': '../../../../return_supplier_invoice/' + this.no
              });
            }
            
            // if (this.del_auth && this.invoice_detail['is_locked'] == '0') {
            //   this.button_list.push({
            //     'id': 'btn_del_ret_supp_inv', 'button_name': 'حذف الفاتورة',
            //     'button_name_en': 'Delete Invoice', 'op_type': 'delete'
            //   });
            // }
          } 
          this.fillTable(this.invoice_detail);
        });
    });
  }

  // search() {
  //   this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
  //     this.router.navigate(['sub_menu/1/invoice_detail/' + this.type + '/' + this.no + '/' + this.source]); // navigate to same route
  //   });
  // }

  fillTable(data) {
    this.top_part = [];
    this.bottom_part = [];
    let today = new Date();
    let rowObj;

    //******************************************* Type: Qutation *******************************************//
    if (this.type == 'qutation') {

      /////////////////////////////////////// fill top part of table ///////////////////////////////////////
      if (this.menu_item_id == '14') {
        rowObj = {
          'col_list': [{ 'class': 'labelTd', 'label': this.Qutation_No + ':' },
          { 'class': 'fieldTd', 'label': data.qutation_no }, { 'class': 'labelTd', 'label': this.Qutation_Date + ':' },
          { 'class': 'fieldTd', 'label': data.qutation_date }]
        };
        this.top_part.push(rowObj);
      }

      else if (this.menu_item_id == '81') {
        rowObj = {
          'col_list': [{ 'class': 'labelTd', 'label': this.Repair_Req_No + ':' },
          { 'class': 'fieldTd', 'label': data.qutation_no }, { 'class': 'labelTd', 'label': this.Repair_Req_Date + ':' },
          { 'class': 'fieldTd', 'label': data.qutation_date }]
        };
        this.top_part.push(rowObj);
      }

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.From_Branch + ':' },
        { 'class': 'fieldTd', 'label': (this.applicationConstants.user_lang == 'ar' ? data.branch_name : data.branch_name_en) }, 
        { 'class': 'labelTd', 'label': this.Print_Date + ':' },
        { 'class': 'fieldTd', 'label': today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() }]
      };
      this.top_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Tax_Number + ':' },
        { 'class': 'fieldTd', 'label': this.company_tax_no }, { 'class': 'labelTd', 'label': '' },
        { 'class': 'fieldTd', 'label': '' }]
      };
      this.top_part.push(rowObj);

      if (this.menu_item_id == '14') {

        rowObj = {
          'col_list': [{ 'class': 'labelTd', 'label': this.Expiry_Date + ':' },
          { 'class': 'fieldTd', 'label': data.expiry_date }, { 'class': 'labelTd', 'label': this.Qutation_Status + ':' },
          { 'class': 'fieldTd', 'label': data.status }]
        };
        this.top_part.push(rowObj);

      }

      if (this.menu_item_id == '81') {
        rowObj = {
          'col_list': [{ 'class': 'labelTd', 'label': this.Appoint_Date + ':' },
          { 'class': 'fieldTd', 'label': data.expiry_date }, { 'class': 'labelTd', 'label': this.Meter_Reading + ':' },
          { 'class': 'fieldTd', 'label': data.meter_reading }]
        };
        this.top_part.push(rowObj);

      }

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Customer_Name + ':' },
        { 'class': 'fieldTd', 'label': data.customer_name + (data.customer_no != '' ? ' (' + data.customer_no + ')' : '') },
        { 'class': 'labelTd', 'label': (data.mobile != '' ? this.Mobile + ':' : '') },
        { 'class': 'fieldTd', 'label': data.mobile }]
      };
      this.top_part.push(rowObj);

      if (data.tax_no != '') {
        rowObj = {
          'col_list': [{ 'class': 'labelTd', 'label': this.Customer_Tax_No + ':' },
          { 'class': 'fieldTd', 'label': data.tax_no }, { 'class': 'labelTd', 'label': '' },
          { 'class': 'fieldTd', 'label': '' }]
        };
        this.top_part.push(rowObj);
      }


      /////////////////////////////////////// fill bottom part of table ///////////////////////////////////////

      // rowObj = { 'col_list': [{ 'class':'labelTd', 'label':'البيان:' }, 
      //   { 'class':'fieldTd', 'label':data.comment }]};
      // this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Amount_Total + ':' },
        { 'class': 'fieldTd', 'label': data.total }, { 'class': 'labelTd', 'label': this.Discount + ':' },
        { 'class': 'fieldTd', 'label': data.discount }]
      };
      this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Total_After_Discount + ':' },
        { 'class': 'fieldTd', 'label': (Number(data.total) - Number(data.discount)).toFixed(2) },
        { 'class': 'labelTd', 'label': this.Taxes + ':' },
        { 'class': 'fieldTd', 'label': data.tax }]
      };
      this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'finalTotal', 'label': this.Total_With_Tax + ':' },
        { 'class': 'finalTotal', 'label': (Number(data.total) - Number(data.discount) + Number(data.tax)).toFixed(2) }]
      };
      this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Employee_Name + ':' },
        { 'class': 'fieldTd', 'label': '--------' }, { 'class': 'labelTd', 'label': '' }, { 'class': 'fieldTd', 'label': '' }]
      };
      this.bottom_part.push(rowObj);
    }

    //******************************************* Type: Invoice *******************************************//
    else if (this.type == 'invoice') {

      /////////////////////////////////////// fill top part of table ///////////////////////////////////////
      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Invoice_No + ':' },
        { 'class': 'fieldTd', 'label': data.invoice_no }, { 'class': 'labelTd', 'label': this.Invoice_Date + ':' },
        { 'class': 'fieldTd', 'label': data.invoice_date }]
      };
      this.top_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.From_Branch + ':' },
        { 'class': 'fieldTd', 'label': (this.applicationConstants.user_lang == 'ar' ? data.branch_name : data.branch_name_en) }, 
        { 'class': 'labelTd', 'label': this.Print_Date + ':' },
        { 'class': 'fieldTd', 'label': today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() }]
      };
      this.top_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Tax_Number + ':' },
        { 'class': 'fieldTd', 'label': this.company_tax_no }, { 'class': 'labelTd', 'label': this.Invoice_Status + ':' },
        { 'class': 'fieldTd', 'label': (this.applicationConstants.user_lang == 'ar' ? data.inv_status : data.inv_status_en) }]
      };
      this.top_part.push(rowObj);

      let href = this.router.url;
      let urlParts = href.split("/");

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Customer_Name + ':' },
        { 'class': 'fieldTd', 'label': data.customer_name + (data.customer_no != '' ? ' (' + data.customer_no + ')' : '') + (urlParts[2] == '12' ? data.mobile : '') },
        { 'class': 'labelTd', 'label': (data.mobile != '' ? this.Mobile + ':' : '') },
        { 'class': 'fieldTd', 'label': (data.mobile != '' ? data.mobile : '') }]
      };
      this.top_part.push(rowObj);

      // rowObj = {
      //   'col_list': [{ 'class': 'labelTd', 'label': (data.mobile != '' ? 'رقم الجوال:' : '') },
      //   { 'class': 'fieldTd', 'label': data.mobile }, { 'class': 'labelTd', 'label': '' },
      //   { 'class': 'fieldTd', 'label': '' }]
      // };
      // this.top_part.push(rowObj);
      rowObj = { 'col_list': [] };
      if (data.tax_no != '') {
        rowObj.col_list.push({ 'class': 'labelTd', 'label': this.Customer_Tax_No + ':' });
        rowObj.col_list.push({ 'class': 'fieldTd', 'label': data.tax_no });
        // rowObj = {
        //   'col_list': [{ 'class': 'labelTd', 'label': 'الرقم الضريبي للعميل:' },
        //   { 'class': 'fieldTd', 'label': data.tax_no }, { 'class': 'labelTd', 'label': '' },
        //   { 'class': 'fieldTd', 'label': '' }]
        // };
      }
      if (data.rep_name != '') {
        rowObj.col_list.push({ 'class': 'labelTd', 'label': this.Representative + ':' });
        rowObj.col_list.push({ 'class': 'fieldTd', 'label': data.rep_name });
      }

      if (rowObj.col_list.length > 0) {
        if (rowObj.col_list.length == 2) {
          rowObj.col_list.push({ 'class': 'labelTd', 'label': '' });
          rowObj.col_list.push({ 'class': 'fieldTd', 'label': '' });
        }
        this.top_part.push(rowObj);
      }

      /////////////////////////////////////// fill bottom part of table ///////////////////////////////////////

      // rowObj = { 'col_list': [{ 'class':'labelTd', 'label':'البيان:' }, 
      //   { 'class':'fieldTd', 'label':data.comment }]};
      // this.bottom_part.push(rowObj);
      if (data.invoice_type == 'advanced' || data.invoice_type == 'install') {
        data.discount = 0;
        
        if (data.invoice_type == 'advanced') 
          data.total = data.advanced_amount;
        else if (data.invoice_type == 'install') 
          data.total = (Number(data.total) - Number(data.advanced_amount)).toFixed(2);
      } 

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Amount_Total + ':' },
        { 'class': 'fieldTd', 'label': data.total }, { 'class': 'labelTd', 'label': this.Discount + ':' },
        { 'class': 'fieldTd', 'label': data.discount }]
      };
      this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Total_After_Discount + ':' },
        { 'class': 'fieldTd', 'label': (Number(data.total) - Number(data.discount)).toFixed(2) },
        { 'class': 'labelTd', 'label': this.Taxes + ':' },
        { 'class': 'fieldTd', 'label': data.tax }]
      };
      this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'finalTotal', 'label': this.Total_With_Tax + ':' },
        { 'class': 'finalTotal', 'label': (Number(data.total) - Number(data.discount) + Number(data.tax)).toFixed(2) },
        { 'class': 'labelTd', 'label': '' }, { 'class': 'fieldTd', 'label': '' }]
      };
      this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Pay_Method + ':' },
        { 'class': 'fieldTd', 'label': (this.applicationConstants.user_lang == 'ar' ? data.payment_method_ar : data.payment_method_en) },
        { 'class': 'labelTd', 'label': '' }, { 'class': 'fieldTd', 'label': '' }]
      };
      this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Employee_Name + ':' },
        { 'class': 'fieldTd', 'label': '--------' }, { 'class': 'labelTd', 'label': '' }, { 'class': 'fieldTd', 'label': '' }]
      };
      this.bottom_part.push(rowObj);
    }

    //**************************************** Type: supplier_invoice ****************************************//
    else if (this.type == 'supplier_invoice') {

      /////////////////////////////////////// fill top part of table ///////////////////////////////////////
      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Invoice_No + ':' },
        { 'class': 'fieldTd', 'label': data.supplier_invoice_no }, { 'class': 'labelTd', 'label': this.Invoice_Date + ':' },
        { 'class': 'fieldTd', 'label': (data.invoice_date).substring(0, 10) }]
      };
      this.top_part.push(rowObj);

      rowObj = {
        'col_list': [
          //{ 'class': 'labelTd', 'label': 'صادرة من فرع:' },
          //{ 'class': 'fieldTd', 'label': '--------' },
          { 'class': 'labelTd', 'label': this.Print_Date + ':' },
          { 'class': 'fieldTd', 'label': today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() },
          { 'class': 'labelTd', 'label': this.Invoice_Status + ':' },
          { 'class': 'fieldTd', 'label': (data.received == '1' ? this.Is_Received : this.Pending) }]
      };
      this.top_part.push(rowObj);

      // rowObj = {
      //   'col_list': [
      //     { 'class': 'labelTd', 'label': 'الرقم الضريبي:' },
      //     { 'class': 'fieldTd', 'label': '--------' },
      //     { 'class': 'labelTd', 'label': 'حالة الفاتورة:' },
      //     { 'class': 'fieldTd', 'label': (data.status == '1' ? 'تم الاستلام' : 'معلقة') }]
      // };
      // this.top_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Supplier_Name + ':' },
        { 'class': 'fieldTd', 'label': data.supplier_name + ' (' + data.supplier_no + ')' },
        { 'class': 'labelTd', 'label': (data.mobile != '' ? this.Mobile + ':' : '') },
        { 'class': 'fieldTd', 'label': data.mobile }]
      };
      this.top_part.push(rowObj);

      // rowObj = {
      //   'col_list': [{ 'class': 'labelTd', 'label': 'رقم المورد:' },
      //   { 'class': 'fieldTd', 'label': data.supplier_no },
      //   { 'class': 'labelTd', 'label': '' },
      //   { 'class': 'fieldTd', 'label': '' }]
      // };
      // this.top_part.push(rowObj);


      /////////////////////////////////////// fill bottom part of table ///////////////////////////////////////

      // rowObj = { 'col_list': [{ 'class':'labelTd', 'label':'البيان:' }, 
      //   { 'class':'fieldTd', 'label':data.comment }]};
      // this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Amount_Total + ':' },
        { 'class': 'fieldTd', 'label': data.amount }, { 'class': 'labelTd', 'label': this.Discount + ':' },
        { 'class': 'fieldTd', 'label': data.discount }]
      };
      this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Total_After_Discount + ':' },
        { 'class': 'fieldTd', 'label': (Number(data.amount) - Number(data.discount)).toFixed(2) },
        { 'class': 'labelTd', 'label': this.Taxes + ':' },
        { 'class': 'fieldTd', 'label': data.tax }]
      };
      this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'finalTotal', 'label': this.Total_With_Tax + ':' },
        { 'class': 'finalTotal', 'label': (Number(data.amount) - Number(data.discount) + Number(data.tax)).toFixed(2) },
        { 'class': 'labelTd', 'label': '' }, { 'class': 'fieldTd', 'label': '' }]
      };
      this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Pay_Method + ':' },
        { 'class': 'fieldTd', 'label': (this.applicationConstants.user_lang == 'ar' ? data.payment_method_ar : data.payment_method_en) },
        { 'class': 'labelTd', 'label': '' }, { 'class': 'fieldTd', 'label': '' }]
      };
      this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Employee_Name + ':' },
        { 'class': 'fieldTd', 'label': '--------' }, { 'class': 'labelTd', 'label': '' },
        { 'class': 'fieldTd', 'label': '' }]
      };
      this.bottom_part.push(rowObj);
    }

    //******************************************* Type: Return Invoice *******************************************//
    else if (this.type == 'return_invoice') {

      /////////////////////////////////////// fill top part of table ///////////////////////////////////////
      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Invoice_No + ':' },
        { 'class': 'fieldTd', 'label': data.return_invoice_no }, { 'class': 'labelTd', 'label': this.Print_Date + ':' },
        { 'class': 'fieldTd', 'label': (data.return_date).substring(0, 10) }]
      };
      this.top_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.From_Branch + ':' },
        { 'class': 'fieldTd', 'label': (this.applicationConstants.user_lang == 'ar' ? data.branch_name : data.branch_name_en) }, 
        { 'class': 'labelTd', 'label': this.Print_Date + ':' },
        { 'class': 'fieldTd', 'label': today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() }]
      };
      this.top_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Tax_Number + ':' },
        { 'class': 'fieldTd', 'label': this.company_tax_no }, { 'class': 'labelTd', 'label': '' },
        { 'class': 'fieldTd', 'label': '' }]
      };
      this.top_part.push(rowObj);

      // if (data.customer_no != '') {
      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Customer_Name + ':' },
        { 'class': 'fieldTd', 'label': data.customer_name + (data.customer_no != '' ? ' (' + data.customer_no + ')' : '') },
        { 'class': 'labelTd', 'label': (data.mobile != '' ? this.Mobile + ':' : '') },
        { 'class': 'fieldTd', 'label': (data.mobile != '' ? data.mobile : '') }]
      };
      this.top_part.push(rowObj);

      if (data.tax_no != '') {
        rowObj = {
          'col_list': [{ 'class': 'labelTd', 'label': this.Customer_Tax_No + ':' },
          { 'class': 'fieldTd', 'label': data.tax_no }, { 'class': 'labelTd', 'label': '' },
          { 'class': 'fieldTd', 'label': '' }]
        };
        this.top_part.push(rowObj);
      }
      // }

      /////////////////////////////////////// fill bottom part of table ///////////////////////////////////////

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Amount_Total + ':' },
        { 'class': 'fieldTd', 'label': data.total }, { 'class': 'labelTd', 'label': this.Discount + ':' },
        { 'class': 'fieldTd', 'label': data.discount }]
      };
      this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Total_After_Discount + ':' },
        { 'class': 'fieldTd', 'label': (Number(data.total) - Number(data.discount)).toFixed(2) },
        { 'class': 'labelTd', 'label': this.Taxes + ':' },
        { 'class': 'fieldTd', 'label': data.tax }]
      };
      this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'finalTotal', 'label': this.Total_With_Tax + ':' },
        { 'class': 'finalTotal', 'label': ((Number(data.total) - Number(data.discount)) + Number(data.tax)).toFixed(2) },
        { 'class': 'labelTd', 'label': '' }, { 'class': 'fieldTd', 'label': '' }]
      };
      this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Pay_Method + ':' },
        { 'class': 'fieldTd', 'label': (this.applicationConstants.user_lang == 'ar' ? data.payment_method_ar : data.payment_method_en) },
        { 'class': 'labelTd', 'label': '' }, { 'class': 'fieldTd', 'label': '' }]
      };
      this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Employee_Name + ':' },
        { 'class': 'fieldTd', 'label': '--------' }, { 'class': 'labelTd', 'label': '' }, { 'class': 'fieldTd', 'label': '' }]
      };
      this.bottom_part.push(rowObj);
    }

    //******************************************* Type: Return Supplier Invoice *******************************************//
    else if (this.type == 'return_supplier_invoice') {

      /////////////////////////////////////// fill top part of table ///////////////////////////////////////
      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Invoice_No + ':' },
        { 'class': 'fieldTd', 'label': data.return_supplier_invoice_no }, { 'class': 'labelTd', 'label': this.Invoice_Date + ':' },
        { 'class': 'fieldTd', 'label': (data.return_date).substring(0, 10) }]
      };
      this.top_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.From_Branch + ':' },
        { 'class': 'fieldTd', 'label': (this.applicationConstants.user_lang == 'ar' ? data.branch_name : data.branch_name_en) }, 
        { 'class': 'labelTd', 'label': this.Print_Date + ':' },
        { 'class': 'fieldTd', 'label': today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() }]
      };
      this.top_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Tax_Number + ':' },
        { 'class': 'fieldTd', 'label': this.company_tax_no }, { 'class': 'labelTd', 'label': '' },
        { 'class': 'fieldTd', 'label': '' }]
      };
      this.top_part.push(rowObj);

      if (data.customer_no != '') {
        rowObj = {
          'col_list': [{ 'class': 'labelTd', 'label': this.Supplier_Name + ':' },
          { 'class': 'fieldTd', 'label': data.supplier_name + ' (' + data.supplier_no + ')' },
          { 'class': 'labelTd', 'label': (data.mobile != '' ? this.Mobile + ':' : '') },
          { 'class': 'fieldTd', 'label': (data.mobile != '' ? data.mobile : '') }]
        };
        this.top_part.push(rowObj);

        if (data.tax_no != '') {
          rowObj = {
            'col_list': [{ 'class': 'labelTd', 'label': this.Supplier_Tax_No + ':' },
            { 'class': 'fieldTd', 'label': data.tax_no }, { 'class': 'labelTd', 'label': '' },
            { 'class': 'fieldTd', 'label': '' }]
          };
          this.top_part.push(rowObj);
        }
      }

      /////////////////////////////////////// fill bottom part of table ///////////////////////////////////////

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Amount_Total + ':' },
        { 'class': 'fieldTd', 'label': data.total }, { 'class': 'labelTd', 'label': this.Discount + ':' },
        { 'class': 'fieldTd', 'label': data.discount }]
      };
      this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Total_After_Discount + ':' },
        { 'class': 'fieldTd', 'label': (Number(data.total) - Number(data.discount)).toFixed(2) },
        { 'class': 'labelTd', 'label': this.Taxes + ':' },
        { 'class': 'fieldTd', 'label': data.tax }]
      };
      this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'finalTotal', 'label': this.Total_With_Tax + ':' },
        { 'class': 'finalTotal', 'label': ((Number(data.total) - Number(data.discount)) + Number(data.tax)).toFixed(2) },
        { 'class': 'labelTd', 'label': '' }, { 'class': 'fieldTd', 'label': '' }]
      };
      this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Pay_Method + ':' },
        { 'class': 'fieldTd', 'label': (this.applicationConstants.user_lang == 'ar' ? data.payment_method_ar : data.payment_method_en) },
        { 'class': 'labelTd', 'label': '' }, { 'class': 'fieldTd', 'label': '' }]
      };
      this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Employee_Name + ':' },
        { 'class': 'fieldTd', 'label': '--------' }, { 'class': 'labelTd', 'label': '' }, { 'class': 'fieldTd', 'label': '' }]
      };
      this.bottom_part.push(rowObj);
    }

    //******************************************* Type: Request *******************************************//
    else if (this.type == 'request') {

      /////////////////////////////////////// fill top part of table ///////////////////////////////////////
      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Request_No + ':' },
        { 'class': 'fieldTd', 'label': data.qutation_no }, { 'class': 'labelTd', 'label': this.Request_Date + ':' },
        { 'class': 'fieldTd', 'label': data.qutation_date }]
      };
      this.top_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.From_Branch + ':' },
        { 'class': 'fieldTd', 'label': '--------' }, { 'class': 'labelTd', 'label': this.Print_Date + ':' },
        { 'class': 'fieldTd', 'label': today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() }]
      };
      this.top_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Request_Type + ':' },
        { 'class': 'fieldTd', 'label': (this.applicationConstants.user_lang == 'ar' ? data.service_method_name : data.service_method_name_en) },
        { 'class': 'labelTd', 'label': (data.table_number != '' ? this.Table_No + ':' : '') },
        { 'class': 'fieldTd', 'label': data.table_number }]
      };
      this.top_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Tax_Number + ':' },
        { 'class': 'fieldTd', 'label': '--------' },
        { 'class': 'labelTd', 'label': (data.invoice_no != '' ? this.Invoice_No + ':' : '') },
        { 'class': 'fieldTd', 'label': (data.invoice_no != '' ? data.invoice_no : '') }]
      };
      this.top_part.push(rowObj);

      // if (this.menu_item_id == '14') {

      //   rowObj = {
      //     'col_list': [{ 'class': 'labelTd', 'label': this.Expiry_Date + ':' },
      //     { 'class': 'fieldTd', 'label': data.expiry_date }, { 'class': 'labelTd', 'label': this.Qutation_Status + ':' },
      //     { 'class': 'fieldTd', 'label': data.status }]
      //   };
      //   this.top_part.push(rowObj);

      // }

      // if (this.menu_item_id == '81') {
      //   rowObj = {
      //     'col_list': [{ 'class': 'labelTd', 'label': this.Appoint_Date + ':' },
      //     { 'class': 'fieldTd', 'label': data.expiry_date }, { 'class': 'labelTd', 'label': this.Meter_Reading + ':' },
      //     { 'class': 'fieldTd', 'label': data.meter_reading }]
      //   };
      //   this.top_part.push(rowObj);

      // }

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Customer_Name + ':' },
        { 'class': 'fieldTd', 'label': data.customer_name + (data.customer_no != '' ? ' (' + data.customer_no + ')' : '') },
        { 'class': 'labelTd', 'label': (data.mobile != '' ? this.Mobile + ':' : '') },
        { 'class': 'fieldTd', 'label': data.mobile }]
      };
      this.top_part.push(rowObj);

      if (data.tax_no != '') {
        rowObj = {
          'col_list': [{ 'class': 'labelTd', 'label': this.Customer_Tax_No + ':' },
          { 'class': 'fieldTd', 'label': data.tax_no }, { 'class': 'labelTd', 'label': '' },
          { 'class': 'fieldTd', 'label': '' }]
        };
        this.top_part.push(rowObj);
      }


      /////////////////////////////////////// fill bottom part of table ///////////////////////////////////////

      // rowObj = { 'col_list': [{ 'class':'labelTd', 'label':'البيان:' }, 
      //   { 'class':'fieldTd', 'label':data.comment }]};
      // this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Amount_Total + ':' },
        { 'class': 'fieldTd', 'label': data.total }, { 'class': 'labelTd', 'label': this.Discount + ':' },
        { 'class': 'fieldTd', 'label': data.discount }]
      };
      this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Total_After_Discount + ':' },
        { 'class': 'fieldTd', 'label': (Number(data.total) - Number(data.discount)).toFixed(2) },
        { 'class': 'labelTd', 'label': this.Taxes + ':' },
        { 'class': 'fieldTd', 'label': data.tax }]
      };
      this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'finalTotal', 'label': this.Total_With_Tax + ':' },
        { 'class': 'finalTotal', 'label': (Number(data.total) - Number(data.discount) + Number(data.tax)).toFixed(2) }]
      };
      this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': (data.payment_method_ar != '' ? this.Pay_Method + ':' : '') },
        { 'class': 'fieldTd', 'label': (data.payment_method_ar != '' ? (this.applicationConstants.user_lang == 'ar' ? data.payment_method_ar : data.payment_method_en) : '') },
        { 'class': 'labelTd', 'label': '' }, { 'class': 'fieldTd', 'label': '' }]
      };
      this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Employee_Name + ':' },
        { 'class': 'fieldTd', 'label': '--------' }, { 'class': 'labelTd', 'label': '' }, { 'class': 'fieldTd', 'label': '' }]
      };
      this.bottom_part.push(rowObj);
    }


    //******************************************* Type: Purchase Order *******************************************//
    if (this.type == 'purchase_order') {

      /////////////////////////////////////// fill top part of table ///////////////////////////////////////
      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Pur_Order_No + ':' },
        { 'class': 'fieldTd', 'label': data.purchase_order_no }, { 'class': 'labelTd', 'label': this.Pur_Order_Date + ':' },
        { 'class': 'fieldTd', 'label': data.purchase_order_date }]
      };
      this.top_part.push(rowObj);


      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.From_Branch + ':' },
        { 'class': 'fieldTd', 'label': '--------' }, { 'class': 'labelTd', 'label': this.Print_Date + ':' },
        { 'class': 'fieldTd', 'label': today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() }]
      };
      this.top_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Tax_Number + ':' },
        { 'class': 'fieldTd', 'label': '--------' }, { 'class': 'labelTd', 'label': '' },
        { 'class': 'fieldTd', 'label': '' }]
      };
      this.top_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Expiry_Date + ':' },
        { 'class': 'fieldTd', 'label': data.expiry_date }, { 'class': 'labelTd', 'label': '' },
        { 'class': 'fieldTd', 'label': '' }]
      };
      this.top_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Supplier_Name + ':' },
        { 'class': 'fieldTd', 'label': data.supplier_name + (data.supplier_no != '' ? ' (' + data.supplier_no + ')' : '') },
        { 'class': 'labelTd', 'label': (data.mobile != '' ? this.Mobile + ':' : '') },
        { 'class': 'fieldTd', 'label': data.mobile }]
      };
      this.top_part.push(rowObj);

      if (data.tax_no != '') {
        rowObj = {
          'col_list': [{ 'class': 'labelTd', 'label': this.Supplier_Tax_No + ':' },
          { 'class': 'fieldTd', 'label': data.tax_no }, { 'class': 'labelTd', 'label': '' },
          { 'class': 'fieldTd', 'label': '' }]
        };
        this.top_part.push(rowObj);
      }


      /////////////////////////////////////// fill bottom part of table ///////////////////////////////////////

      // rowObj = { 'col_list': [{ 'class':'labelTd', 'label':'البيان:' }, 
      //   { 'class':'fieldTd', 'label':data.comment }]};
      // this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Amount_Total + ':' },
        { 'class': 'fieldTd', 'label': data.total }, { 'class': 'labelTd', 'label': this.Discount + ':' },
        { 'class': 'fieldTd', 'label': data.discount }]
      };
      this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Total_After_Discount + ':' },
        { 'class': 'fieldTd', 'label': (Number(data.total) - Number(data.discount)).toFixed(2) },
        { 'class': 'labelTd', 'label': this.Taxes + ':' },
        { 'class': 'fieldTd', 'label': data.tax }]
      };
      this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'finalTotal', 'label': this.Total_With_Tax + ':' },
        { 'class': 'finalTotal', 'label': (Number(data.total) - Number(data.discount) + Number(data.tax)).toFixed(2) }]
      };
      this.bottom_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Employee_Name + ':' },
        { 'class': 'fieldTd', 'label': '--------' }, { 'class': 'labelTd', 'label': '' }, { 'class': 'fieldTd', 'label': '' }]
      };
      this.bottom_part.push(rowObj);
    }


    this.dp = data['item_list'];
    this.dataSource = new MatTableDataSource(this.dp);
    this.dataSource.sort = this.sort;
  }

  search() {
    this.ngOnInit();
  }

  do(value, event) {
    console.log(value);

    if (value == 'print') {
      if (this.menu_item_id == '81')
        window.open(this.applicationConstants.generatePDF + "?type=qutation&is_maint=1&no=" + this.no, "_blank");

      else {
        if (this.type == 'invoice')
          window.open(this.applicationConstants.generateInvoice + "?no=" + this.no, "_blank");
        else if (this.type == 'request') 
          window.open(this.applicationConstants.generateInvoice + "?no=" + this.invoice_detail['invoice_no'], "_blank");
        else
          window.open(this.applicationConstants.generatePDF + "?type=" + this.type + "&no=" + this.no, "_blank");
      }
    }

    else if (value == 'printThermal') {
      if (this.type == 'invoice')
        window.open(this.applicationConstants.generateThermalInvoice + "?no=" + this.no, "_blank");
      else if (this.type == 'request') {
        if (this.invoice_detail['invoice_no'] != '')
          window.open(this.applicationConstants.generateThermalInvoice + "?no=" + this.invoice_detail['invoice_no'], "_blank");
        else
          window.open(this.applicationConstants.generateThermalInvoice + "?type=request&no=" + this.invoice_detail['qutation_no'], "_blank");
      }
    }

    else if (value == 'cancel') {

      let dialog_data = [{ 'invoice_no': this.invoice_detail['invoice_no'], 'invoice_date': this.invoice_detail['invoice_date'] }];
      this.returnDateDialogRef = this.dialog.open(ReturnAllDateComponent, {
        hasBackdrop: false,
        data: dialog_data
      });
      this.returnDateDialogRef
        .afterClosed()
        .subscribe(result => {
          if (result != null && result['op_type'] == 'success') {
            let invoice_detail = this.invoice_detail;
            invoice_detail['item_list'] = undefined;
            this.utils.returnSaleInvoice(invoice_detail, result['return_date'], this);

            // if (this.type == 'invoice')
            //   this.utils.returnSaleInvoice(this.invoice_detail, result['return_date'], this);
            // else if (this.type == 'request') {
            //   let invoice_detail = this.invoice_detail;
            //   invoice_detail['item_list'] = undefined;
            //   this.utils.returnSaleInvoice(invoice_detail, result['return_date'], this);
            // }
          }
        });

      // if (confirm(this.Ret_All_Msg)) {
      //   if (this.type == 'invoice')
      //     this.utils.returnSaleInvoice(this.invoice_detail, this);
      //   else if (this.type == 'request') {
      //     let invoice_detail = this.invoice_detail;
      //     invoice_detail['item_list'] = undefined;
      //     this.utils.returnSaleInvoice(invoice_detail, this);
      //   }
      // }
    }

    else if (value == 'delete') {
      let btn_id = event.srcElement.id;
      let values = [];
      let router = '';

      if (confirm(this.Del_Msg)) {
        if (btn_id == 'btn_del_qutation') {
          values = [{ 'table_name': 'qutation', 'qutation_no': this.no }];
          values.push({ 'table_name': 'qutation_item', 'qutation_no': this.no });

          router = 'sub_menu/1/qutation_list';
        }

        else if (btn_id == 'btn_del_sup_inv') {
          values = [{ 'table_name': 'supplier_invoice', 'invoice_no': this.no }];
          values.push({ 'table_name': 'supplier_invoice_item', 'invoice_no': this.no });
          values.push({ 'table_name': 'supp_inv_payment_method', 'invoice_no': this.no });
          values.push({ 'table_name': 'stock', 'invoice_no': this.no });
          values.push({ 'table_name': 'stock_base', 'invoice_no': this.no });

          router = 'sub_menu/7/supplier_invoice_list';
        }

        else if (btn_id == 'btn_del_ret_inv') {
          values.push({ 'table_name': 'return_invoice', 'return_invoice_no': this.no });
          values.push({ 'table_name': 'return_invoice_item', 'return_invoice_no': this.no });
          values.push({ 'table_name': 'ret_inv_payment_method', 'return_invoice_no': this.no });
          values.push({ 'table_name': 'stock_damage', 'return_invoice_no': this.no });

          router = 'sub_menu/1/return_invoice_list';
        }

        else if (btn_id == 'btn_del_ret_supp_inv') {
          values.push({ 'table_name': 'return_supplier_invoice', 'return_supplier_invoice_no': this.no });
          values.push({ 'table_name': 'return_supplier_invoice_item', 'return_supplier_invoice_no': this.no });
          values.push({ 'table_name': 'ret_supp_inv_payment_method', 'return_supplier_invoice_no': this.no });

          router = 'sub_menu/7/return_supplier_invoice_list';
        }

        else if (btn_id == 'btn_del_request') {
          values.push({ 'table_name': 'qutation', 'qutation_no': this.no });
          values.push({ 'table_name': 'qutation_item', 'qutation_no': this.no });

          if (this.invoice_detail['invoice_no'] != '') {
            values.push({ 'table_name': 'invoice', 'invoice_no': this.invoice_detail['invoice_no'] });
            values.push({ 'table_name': 'invoice_item', 'invoice_no': this.invoice_detail['invoice_no'] });
            values.push({ 'table_name': 'inv_payment_method', 'invoice_no': this.invoice_detail['invoice_no'] });
          }

          router = 'sub_menu/1/request_list';
        }

        else if (btn_id == 'btn_del_order') {
          values = [{ 'table_name': 'purchase_order', 'purchase_order_no': this.no }];
          values.push({ 'table_name': 'purchase_order_item', 'purchase_order': this.no });

          router = 'sub_menu/1/purchase_order_list';
        }
        let obj;
        obj = { cmd: 'deleteRec', values: values };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            //console.log(data);
            if (data.status['type'] == 'success') {
              if (btn_id == 'btn_del_request') {
                values = [{ 'table_name': 'serv_table', 'qutation_no': '', 'res_status': '1' }];
                let where = [{ 'qutation_no': this.no }];
                obj = { cmd: 'update', values: values, where: where };

                this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                  .subscribe(data => {
                    this.applicationConstants.appComp.hideBusyCursor();

                    if (data.status['type'] == 'success') {
                      alert(this.Success_Msg);
                      this.router.navigate([router]);
                    }
                    else {
                      alert(this.Error_Msg);
                    }
                  });
              }
              else {
                alert(this.Success_Msg);
                this.router.navigate([router]);
              }
            }
            else {
              alert(this.Error_Msg);
            }
          });
      }
    }

    else if (value == 'print_delivery')
      window.open(this.applicationConstants.generatePDF + "?type=invoice&delivery=true&no=" + this.no, "_blank");

    else if (value == 'print_receipt')
      window.open(this.applicationConstants.generatePDF + "?type=supplier_invoice&received=true&no=" + this.no, "_blank");

    else if (value == 'free_table') {
      let values = [{ 'table_name': 'serv_table', 'qutation_no': '', 'res_status': '1' }];
      let where = [{ 'qutation_no': this.no }];
      let obj = { cmd: 'update', values: values, where: where };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
              this.router.navigate(['sub_menu/' + this.urlParts[2] + '/invoice_detail/' + this.type + '/' + this.no + '/' + this.source]); // navigate to same route
            });
            // this.ngOnInit();
            // this.router.navigate(['sub_menu/1/request_lis']);
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }

    else if (value == 'delivery') {

      var deliver_date = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + 
        new Date().getDate() + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + 
        new Date().getSeconds();

      let values = [{ 'table_name': 'invoice', 'status': '1', 'deliver_date': deliver_date }];
      let where = [{ 'invoice_no': this.no }];
      let obj = { cmd: 'update', values: values, where: where };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
              this.router.navigate(['sub_menu/' + this.urlParts[2] + '/invoice_detail/' + this.type + '/' + this.no + '/' + this.source]); // navigate to same route
            });
            // this.ngOnInit();
            // this.router.navigate(['sub_menu/1/invoice_detail/' + this.no]);
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }

    else if (value == 'receive') {
      var receipt_date = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + 
        new Date().getDate() + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + 
        new Date().getSeconds();

      let values = [{ 'table_name': 'supplier_invoice', 'received': '1', 'receipt_date': receipt_date }];
      let where = [{ 'invoice_no': this.no }];
      let obj = { cmd: 'update', values: values, where: where };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.status['type'] == 'success') { 
            alert(this.Success_Msg);
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
              this.router.navigate(['sub_menu/' + this.urlParts[2] + '/invoice_detail/' + this.type + '/' + this.no + '/' + this.source]); // navigate to same route
              // this.router.navigate(['sub_menu/4/invoice_detail/' + this.type + '/' + this.no]); 
            });
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
    
    else if (value == 'edit') {
      if (this.type == 'return_invoice') {
        if (this.invoice_detail['invoice_no'] != '')
          this.router.navigate(['sub_menu/1/return_invoice/' + this.no]);
        else
          this.router.navigate(['sub_menu/1/invoice/return_invoice/edit/' + this.no]);
      }
    }

    // else if (value == 'return_inv') {
    //   this.router.navigate(['sub_menu/1/return_invoice', { 'no': this.no }]);
    // }
  }


}
